<template>
  <v-layout align-center>
    <v-flex xs12 sm10 md8>
      <v-layout wrap>
        <v-flex xs12>
          <form v-scroll-to-error @submit.prevent="submitForm">
            <div class="screen-title mb-0">
              <span>{{ adminText('workflowsAll.create_announcement_ab68a44', 'Create Announcement') }}</span>
            </div>
            <div class="mb-32 title-description">
              {{ adminText('workflowsAll.you_need_to_provide_information_about_your_ne_bb502bf', 'You need to provide information about your new announcement.') }}
            </div>
            <announcement-form
              :vs="$v"
              :initial-values="form"
              @values="form=$event"
            />
            <main-button
              :text="adminText('workflowsAll.create_6e157c5', 'Create')"
              depressed
              :loading="loading"
              @click="$emit('submit')"
            />
            <main-button
              :text="adminText('workflowsAll.cancel_77dfd21', 'Cancel')"
              flat
              @click.prevent="goBack"
            />
          </form>
        </v-flex>
      </v-layout>
    </v-flex>
    <error-snackbar
      :open.sync="showErrorSnackbar"
      :title="adminText('workflowsAll.oops_c8e633f', 'Oops')"
      :message="adminText('workflowsAll.something_went_wrong_ccbbe60', 'Something went wrong...')"
    />
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { required } from 'vuelidate/lib/validators'

import ErrorSnackbar from '../shared/snackbars/errors-snackbar'
import AnnouncementForm from './announcement-form.vue'
import MainButton from './../shared/main-button.vue'
import {createAnnouncement} from './../../http'
import { submitGuard } from './../../utils'

export default {
  mixins: [WorkflowDisplay],
  name: 'new-announcement-container',
  components: {
    AnnouncementForm,
    MainButton,
    ErrorSnackbar,
  },
  props: {
    eventId: {
      default: null,
      type: String,
    },
  },
  validations() {
    const component = this

    return {
      form: {
        title: { required },
        text: { required },
      },
    }
  },
  data: () => ({
    form: {},
    loading: false,
    showErrorSnackbar: false,
  }),
  methods:{
    async submitForm() {
      await submitGuard(this, async () =>{
        const setLoading = setTimeout(() => this.loading = true, 500)
        const { errors } = await createAnnouncement(this.eventId, this.form)

        if (!this.loading) clearTimeout(setLoading)

        if (!errors) return this.goBack()

        this.showErrorSnackbar = true
        this.loading = false
      })
    },
  },
}
</script>

<style>
</style>
